import { compose, setDisplayName, withProps } from 'recompose';
import { connect } from 'formik';

import { renderIf } from '../../../hoc/renderIf';

const shouldRender = ({ name, formik: { errors, touched } }) =>
  errors[name] && touched[name];

export const enhance = compose(
  setDisplayName('ErrorEnhanced'),
  connect,
  withProps(({ formik: { errors }, name, value }) => ({
    value: value || errors[name],
  })),
  renderIf(shouldRender)
);
